import request from "@/utils/request";
import qs from "qs-lite";

import {
  ICustomerPostResponse,
  ICustomer,
} from "@/interfaces/responses/customer";
import { SharedCallbacks } from "@/utils/shared-resources";

/**
 * Create new customer
 * Postman: `Customer create`
 */
export async function postCustomer({
  groupId,
  ...data
}: {
  groupId: number;
  data: any;
}): Promise<ICustomerPostResponse> {
  const params: { [posConfigId: string]: number | undefined } = {};

  const getPOSConfigId = SharedCallbacks.getPOSConfigId;
  if (getPOSConfigId) {
    params.posConfigId = getPOSConfigId();
  }

  const response = await request({
    url: `/group/${groupId}/customer`,
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: qs.stringify(data),
    params,
  });

  return response.data;
}

/**
 * Edit customer
 */
export async function patchCustomer({
  groupId,
  customerId,
  ...data
}: {
  groupId: number;
  customerId: number;
  // eslint-disable-next-line
  data: any;
}): Promise<ICustomer> {
  const params: { [posConfigId: string]: number | undefined } = {};

  const getPOSConfigId = SharedCallbacks.getPOSConfigId;
  if (getPOSConfigId) {
    params.posConfigId = getPOSConfigId();
  }

  const response = await request({
    url: `/group/${groupId}/customer/${customerId}`,
    method: "patch",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: qs.stringify(data),
    params,
  });

  if (response.data.status !== "success") {
    throw new Error("error when updating the customer's data");
  }
  return response.data.data.customers;
}
